export type COMPANIES = "Dalakraft" | "Enkla";

type COMPANY_MARKINGS_GROUP = {
  [key in COMPANIES]: 1 | 6;
};
export const COMPANY_MARKINGS_GROUP: COMPANY_MARKINGS_GROUP = {
  Dalakraft: 1,
  Enkla: 6,
};